<template>
    <van-overlay :show="visible" :lock-scroll="lockScroll" v-bind="$attrs" @click="handleClose" :z-index="3001">
        <div @click.stop class="dialog-content">
            <div class="dialog-title">
                {{ $t(title) }}
                <div v-if="showClose" class="close" @click="handleClose"></div>
            </div>
            <div class="dialog-inner">
                <slot></slot>
            </div>
        </div>
    </van-overlay>
</template>
<script setup lang="ts">
const props = defineProps({
    showClose: {
        type: Boolean,
        default: () => true,
    },
    lockScroll: {
        type: Boolean,
        default: () => false,
    },
    title: {
        type: String,
        default: () => '',
    },
    canClosed: {
        type: Boolean,
        default: () => true,
    },
})
const emits = defineEmits(['close'])

const visible = defineModel()
const handleClose = () => {
    if (props.canClosed) {
        visible.value = false
        emits('close')
    }
}
</script>
<style lang="scss" scoped>
.dialog-content {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 690px;
    background: #42355a;
    border-radius: 30px;
    overflow: hidden;
    font-family: MicrosoftYaHei;
    color: #fff;

    transform: translate3d(-50%, -50%, 0);

    .dialog-title {
        @apply flex justify-center items-center;
        position: relative;
        height: 108px;
        background: url('@/assets/img/dialog/title_bg.png') no-repeat;
        background-size: 100% 100%;
        font-size: 40px;
        font-weight: bold;

        .close {
            position: absolute;
            top: 0;
            right: 0;
            width: 63px;
            height: 108px;
            background: url('@/assets/img/new-home/close.png') no-repeat left center;
            background-size: 33px 34px;
        }
    }
}
</style>
